import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useCheckout = () => {
  const [loading, setLoading] = useState(false);

  const go = async (payload) => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/payments/stripe/checkout`, {
        ...payload,
        origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      setLoading(false);
    }
  };

  const buy = (lookupKey) => go({ lookup_key: lookupKey, quantity: 1 });
  const buyItems = (items) => go({ items });

  return { buy, buyItems, loading };
};
